<template>
  <div>首页</div>
</template>
<script>
export default {
  name: 'HomePage',
  methods: {
    // 获取数据
    async BindData() {
      const { data: res } = await this.$http.post('/userInfo/list')
      if (res.code === 500) {
        this.$message.error(res.msg)
        return
      }
      this.tableData = res.data
    },
  },
  mounted() {
    this.BindData()
  }
}
</script>
<style lang='less' scoped>
</style>